import { useDataModelStore } from "./dataModel";
import { usePaginatedListStore } from "./paginatedList";
import VueApiQueryList from "@/models/lists/VueApiQueryList";
import Account from "@/models/Account";
import User from "@/models/User";
import Resource from "@/models/Resource";
import Tag from "@/models/Tag";
import Author from "@/models/Author";
import AssignedResource from "@/models/AssignedResource";
import Collection from "@/models/Collection";

const CreateResourceModel = function() {
    return new Resource();
};
const CreateAuthorModel = function() {
    return new Author();
};
const CreateCollectionModel = function() {
    return new Collection();
};
const CreateTagModel = function() {
    return new Tag();
};

const Tags = new VueApiQueryList(CreateTagModel);
const Resources = new VueApiQueryList(function(id, context, extra) {
    switch (context){
        case "author": {
            return new Resource().for(new Author({ id: id }));
        }
        case "collection": {
            return new Resource().for(new Collection({ id: id }));
        }
        case "liked": {
            return Resource.custom(
                new Author({ id: id }),
                "liked",
                new Resource()
            );
        }
        case "assigned": {
            let accountId = extra?.account_id;
            let userId = id;
            if (!accountId || !userId) {
                throw new Error("no user");
            }

            let account = new Account({ id: accountId });
            let user = new User({ id: userId });
            return new AssignedResource().for(account, user);
        }
    }

    return new Resource();
}, CreateResourceModel);



const Collections = new VueApiQueryList(function(id, context) {
    switch (context){
        case "author": {
            return new Collection().for(new Author({ id: id }));
        }
    }
    return new Collection();
}, CreateCollectionModel);

const Authors = new VueApiQueryList(CreateAuthorModel);


export const useTagStore = useDataModelStore('tag', Tags);
export const useResourceStore = useDataModelStore('resource', Resources);
export const useCollectionStore = useDataModelStore('collection', Collections);
export const useAuthorStore = useDataModelStore('author', Authors);

export const usePopularTagsStore = usePaginatedListStore('popularTags', useTagStore);

export const useLatestResourcesStore = usePaginatedListStore('latestResources', useResourceStore);
export const useAuthorResourcesStore = usePaginatedListStore('latestAuthorResources', useResourceStore);
export const useLikedResourcesStore = usePaginatedListStore('latestLikedResources', useResourceStore);
export const useAssignedResourcesStore = usePaginatedListStore('latestAssignedResources', useResourceStore);
export const useCollectionResourcesStore = usePaginatedListStore('latestCollectionResources', useResourceStore);

export const useLatestCollectionsStore = usePaginatedListStore('latestCollections', useCollectionStore);
export const useAuthorCollectionsStore = usePaginatedListStore('authorCollections', useCollectionStore);
